import { inr } from "../../utils/helpers";

export default function PlanCard({ plan, current, onBuy }) {
  return (
    <article className={`glass rounded-app p-4 ${current ? "ring-2 ring-violet-500" : ""}`}>
      <div className="flex items-center justify-between"><h3 className="text-lg font-black">{plan.name}</h3><strong>{plan.price ? `${inr(plan.price)}` : "Free"}</strong></div>
      <ul className="my-4 grid gap-2 text-sm text-tg-hint">{plan.features.map((f) => <li key={f}>✓ {f}</li>)}</ul>
      <button onClick={() => onBuy(plan)} className="tap w-full rounded-app bg-violet-600 py-3">{current ? "Current Plan" : "Choose Plan"}</button>
    </article>
  );
}
